module.exports = __webpack_public_path__ + "static/media/200347.d0091687.jpg";